var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bytedanceLoading"},[_c('div',{staticClass:"bytedanceLoading__wrapper"},[_c('div',{staticClass:"bytedanceLoading__inner"},[_c('div',{staticClass:"bytedanceLoading__inner-item"}),_c('div',{staticClass:"bytedanceLoading__inner-item"}),_c('div',{staticClass:"bytedanceLoading__inner-item"}),_c('div',{staticClass:"bytedanceLoading__inner-item"})])])])
}]

export { render, staticRenderFns }